<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <b-form-group class="col-md-6">
        <label for="estado">
          Estado <span style="color: red">(*)</span>
        </label>
        <b-form-input id="estado"
                      name="estado"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.estado"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.estado')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="color">
          Color <span style="color: red">(*)</span>
        </label>
        <b-form-input id="color"
                      name="color"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.color"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.color')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <b-form-group class="col-md-6">
        <label for="solubilidad">
          Solubilidad <span style="color: red">(*)</span>
        </label>
        <b-form-input id="solubilidad"
                      name="solubilidad"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.solubilidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.solubilidad')"
        />
      </b-form-group>
      <b-form-group class="col-md-6">
        <label for="umbral_olor">
          Umbral del olor <span style="color: red">(*)</span>
        </label>
        <b-form-input id="umbral_olor"
                      name="umbral_olor"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.umbral_olor"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.umbral_olor')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- Presion de Vapor -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Presión de vapor"
        v_model_range="presion_vapor_rango"
        v_model="presion_vapor"
        :required="true"
        v_model_up_to="presion_vapor_hasta"
        v_model_um="id_um_presion_vapor"
        um_type="UPRES"
        :values="selectedSeccion9"
      />
      <!-- Densidad de vapor relativo -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Densidad de vapor relativo"
        v_model_range="densidad_vapor_relativo_rango"
        v_model="densidad_vapor_relativo"
        :required="true"
        v_model_up_to="densidad_vapor_relativo_hasta"
        v_model_um="id_um_densidad_vapor_relativo"
        um_type="uniden"
        :values="selectedSeccion9"
      />
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <!-- Punto de inflamación -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Punto de inflamación"
        v_model_range="punto_inflamacion_rango"
        v_model="punto_inflamacion"
        :required="true"
        v_model_up_to="punto_inflamacion_hasta"
        v_model_um="id_um_punto_inflamacion"
        um_type="UTEMP"
        :values="selectedSeccion9"
      />
      <!-- Limite inferior y superior de inflamabilidad -->
      <b-form-group class="col-md-6">
        <label for="limite_inf_sup_inflamabilidad">
          Límite inferior y superior de inflamabilidad <span style="color: red">(*)</span>
        </label>
        <b-form-input id="limite_inf_sup_inflamabilidad"
                      name="limite_inf_sup_inflamabilidad"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.limite_inf_sup_inflamabilidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.limite_inf_sup_inflamabilidad')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- Temperatura de ignición espontánea -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Temperatura de ignición espontánea"
        v_model_range="temperatura_ignicion_espontanea_rango"
        v_model="temperatura_ignicion_espontanea"
        :required="true"
        v_model_up_to="temperatura_ignicion_espontanea_hasta"
        v_model_um="id_um_temperatura_ignicion_espontanea"
        um_type="UTEMP"
        :values="selectedSeccion9"
      />
      <!-- Densidad -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Densidad"
        v_model_range="densidad_rango"
        v_model="densidad"
        :required="true"
        v_model_up_to="densidad_hasta"
        v_model_um="id_um_densidad"
        um_type="uniden"
        :values="selectedSeccion9"
      />
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <!-- Temperatura de descomposición -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Temperatura de descomposición"
        v_model_range="temperatura_descomposicion_rango"
        v_model="temperatura_descomposicion"
        :required="true"
        v_model_up_to="temperatura_descomposicion_hasta"
        v_model_um="id_um_temperatura_descomposicion"
        um_type="UTEMP"
        :values="selectedSeccion9"
      />
      <!-- Coeficiente de reparto n-octanol/agua -->
      <b-form-group class="col-md-6">
        <label for="coeficiente_reparto">
          Coeficiente de reparto n-octanol/agua <span style="color: red">(*)</span>
        </label>
        <b-form-input id="coeficiente_reparto"
                      name="coeficiente_reparto"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.coeficiente_reparto"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.coeficiente_reparto')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- ph -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="pH"
        v_model_range="ph_rango"
        v_model="ph"
        :required="true"
        v_model_up_to="ph_hasta"
        :values="selectedSeccion9"
      />
      <!-- Viscosidad Cinemática -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Viscosidad Cinemática"
        v_model_range="viscosidad_cinematica_rango"
        v_model="viscosidad_cinematica"
        :required="true"
        v_model_up_to="viscosidad_cinematica_hasta"
        v_model_um="id_um_viscosidad_cinematica"
        um_type="UVISC"
        :values="selectedSeccion9"
      />
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <!-- Punto de fusión -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Punto de fusión"
        v_model_range="punto_fusion_rango"
        v_model="punto_fusion"
        :required="true"
        v_model_up_to="punto_fusion_hasta"
        v_model_um="id_um_punto_fusion"
        um_type="UTEMP"
        :values="selectedSeccion9"
      />
      <!-- Punto de congelación -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Punto de congelación"
        v_model_range="punto_congelacion_rango"
        v_model="punto_congelacion"
        :required="true"
        v_model_up_to="punto_congelacion_hasta"
        v_model_um="id_um_punto_congelacion"
        um_type="UTEMP"
        :values="selectedSeccion9"
      />
    </b-form-row>
    <b-form-row>
      <!-- Punto de ebullición -->
      <BInputUm
        bv_class="col-md-6"
        parentState="selectedSeccion9"
        input_text="Punto de ebullición"
        v_model_range="punto_ebullicion_rango"
        v_model="punto_ebullicion"
        :required="true"
        v_model_up_to="punto_ebullicion_hasta"
        v_model_um="id_um_punto_ebullicion"
        um_type="UTEMP"
        :values="selectedSeccion9"
      />
      <!-- Otras propiedades -->
      <b-form-group class="col-md-6">
        <label for="otras_propiedades">
          Otras propiedades <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="otras_propiedades"
                         name="otras_propiedades"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion9.otras_propiedades"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.otras_propiedades')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <!-- Gravedad especifica -->
      <b-form-group class="col-md-6">
        <label for="gravedad_especifica">
          Gravedad especifica (25°C) <span style="color: red">(*)</span>
        </label>
        <b-form-input id="gravedad_especifica"
                      name="gravedad_especifica"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.gravedad_especifica"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.gravedad_especifica')"
        />
      </b-form-group>
      <!-- Inflamabilidad -->
      <b-form-group class="col-md-6">
        <label for="inflamabilidad">
          Inflamabilidad <span style="color: red">(*)</span>
        </label>
        <b-form-input id="inflamabilidad"
                      name="inflamabilidad"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.inflamabilidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.inflamabilidad')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- Punto fluidez -->
      <b-form-group class="col-md-6">
        <label for="punto_fluidez">
          Punto de fluidez <span style="color: red">(*)</span>
        </label>
        <b-form-input id="punto_fluidez"
                      name="punto_fluidez"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.punto_fluidez"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.punto_fluidez')"
        />
      </b-form-group>
      <!-- Contenido compuestos volatiles -->
      <b-form-group class="col-md-6">
        <label for="contenido_compuestos_volatiles">
          Contenido de compuestos orgánicos volátiles <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="contenido_compuestos_volatiles"
                      name="contenido_compuestos_volatiles"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.contenido_compuestos_volatiles"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.contenido_compuestos_volatiles')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row class="bg-row-gray">
      <!-- Porcentaje de volatilidad -->
      <b-form-group class="col-md-6">
        <label for="porcentaje_volatilidad">
          Porcentaje de volatilidad <span style="color: red">(*)</span>
        </label>
        <b-form-input id="porcentaje_volatilidad"
                      name="porcentaje_volatilidad"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.porcentaje_volatilidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.porcentaje_volatilidad')"
        />
      </b-form-group>
      <!-- Concentración de vapor saturado -->
      <b-form-group class="col-md-6">
        <label for="concentracion_vapor_saturado">
          Concentración de vapor saturado <span style="color: red">(*)</span>
        </label>
        <b-form-input id="concentracion_vapor_saturado"
                      name="concentracion_vapor_saturado"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.concentracion_vapor_saturado"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.concentracion_vapor_saturado')"
        />
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- Peso molecular -->
      <b-form-group class="col-md-6">
        <label for="peso_molecular">
          Peso molecular <span style="color: red">(*)</span>
        </label>
        <b-form-input id="peso_molecular"
                     name="peso_molecular"
                     required
                     data-vv-as=" "
                     v-model="selectedSeccion9.peso_molecular"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.peso_molecular')"
        />
      </b-form-group>
      <!-- Características de partículas -->
      <b-form-group class="col-md-6">
        <label for="carateristicas_particulas">
          Características de las partículas <span style="color: red">(*)</span>
        </label>
        <b-form-input id="carateristicas_particulas"
                      name="carateristicas_particulas"
                      required
                      data-vv-as=" "
                      v-model="selectedSeccion9.carateristicas_particulas"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion9.carateristicas_particulas')"
        />
      </b-form-group>
    </b-form-row>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import BInputUm from "../../componentes/BInputUm";

export default {
  name: "FDS-Seccion9",
  components: {
    FooterButtons,
    BInputUm
  },
  data() {
    return {
    }
  },
  async created() {
    await this.setSeccionActual(9);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion'
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion9',
      'error'
    ])
  }
}
</script>
<style scoped>
  .bg-row-gray {
    background-color: #f0f3f5 !important;
    margin-top: 0.5em !important;
    padding-top: 0.5em !important;
    margin-bottom: 0.5em !important;
    padding-bottom: 0.5em !important;
  }
</style>
